import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';

const getExtraRooms = (state) => state.get('extraRooms');
const _getExtraRoomsOffers = (state) => getExtraRooms(state).get('data');

export const getExtraRoomsOriginalPackageId = (state) =>
  getExtraRooms(state).get('originalPackageId');
export const getExtraRoomsIsRequestCreated = (state) =>
  getExtraRooms(state).get('isRequestCreated');

export const getExtraRoomsOffers = createSelector(
  _getExtraRoomsOffers,
  (offers) => offers && offers.toJS(),
);

export const getExtraRoomsPackageId = createSelector(
  [getExtraRoomsOffers, getExtraRoomsOriginalPackageId],
  (offers, originalPackageId) => {
    if (isEmpty(offers)) {
      return null;
    }

    return offers
      .filter((offer) => offer.package_id !== originalPackageId)
      .reduce((result, item) => [...result, item.package_id], []);
  },
);
